<template>
  <div class="stand-card color-card background-gray column is-12">
    <div class="columns is-mobile pa-0">
      <div class="column pa-0 img-container is-2">
        <img slot="image" src="@/assets/specie1.png" />
      </div>
      <div class="column pa-0 head">
        <div>
          <div v-if="index && total" class="has-text-grey">
            <b>{{ $t("page.labels.stand") }}: {{ index }}</b>
            / {{ total }}
          </div>
          <h4 v-if="stand.silvicultural_model" class="has-text-primary is-size-6">
            {{ stand.silvicultural_model.name }}
          </h4>
        </div>
      </div>
    </div>
    <div class="body mt-3">
      <p v-if="stand.specie">
        <label>{{ $t("page.labels.specie") }}:</label>
        <span v-if="stand.specie">
          {{ $t(`species.${spacesToUnderscores(stand.specie)}`) }}
        </span>
      </p>
      <p v-if="stand.plantation_year">
        <label>{{ $t("page.labels.plantation_year") }}:</label>
        <span>{{ stand.plantation_year }}</span>
      </p>
      <p v-if="stand.area">
        <label>{{ $t("page.labels.area") }}:</label>
        <span>{{ stand.area || stand.parcel.area | areaToHA }} ha</span>
      </p>

      <ul class="mt-2 silvicultural-models-list" v-if="silviculturalModels.length > 0">
        <li class="is-flex" v-for="(item, key) in silviculturalModels" :key="key">
          <article :class="['collapsible-article', { active: item.expanded }]">
            <header
              class="header background-gray"
              @click="item.expanded = !item.expanded"
            >
              <h1 class="py-2 pl-2 pr-1">{{ item.article.title }}</h1>
              <div class="arrow"></div>
            </header>
            <div class="body pa-2" v-if="item.expanded">
              <div v-html="$options.filters.nl2p(item.article.body)" />
              <div v-if="item.article.attachments">
                <div
                  class="attachment"
                  v-for="(filename, index) in item.article.attachments.split(' ')"
                  :key="index"
                >
                  <img
                    @click="windowOpen(docsResource(filename))"
                    :src="docsResource(filename)"
                  />
                </div>
              </div>
            </div>
          </article>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import BikentapediaMixin from "@/mixins/BikentapediaMixin"
import _ from "lodash"

const MODELS_MAPPING = {
  PP1: 6,
  PP2: 7,
  PR1: 8,
  PR2: 9,
  EG1: 10,
  EG2: 11,
  EN1: 12,
  EN2: 13,
  reserve: 14,
}

export default {
  name: "StandCard",
  mixins: [BikentapediaMixin],
  props: ["stand", "index", "total"],
  data() {
    return {
      silviculturalModels: [],
    }
  },
  methods: {
    getSilviculturalModels() {
      const key = _.get(this, "stand.silvicultural_model.code")
      const articleId = key ? _.get(MODELS_MAPPING, key, null) : null
      this.silviculturalModels = articleId
        ? [{ article: this.articles[articleId], expanded: false }]
        : []
    },
    spacesToUnderscores(str) {
      return str ? str.replace(" ", "_") : ""
    },
  },
  mounted() {
    this.getSilviculturalModels()
  },
}
</script>
